import { type ISearchParam } from '@interface/ICommon';
import { type IPriceItemList, type IPriceParams } from '@interface/IItemPrice';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';
import { PriceItem } from './PriceItem';

export const PriceList = ({
    listData,
    priceListParam,
    loading,
    firstSvrId,
    params,
}: {
    listData: IPriceItemList['contents'] | undefined;
    priceListParam: ISearchParam;
    loading: boolean;
    firstSvrId: string;
    params: IPriceParams;
}) => {
    const { t } = useTranslation();
    const [svrid, svridSet] = useState('');

    useEffect(() => {
        let svrId = params.paramServerid;
        if (!svrId) svrId = firstSvrId || 'all';
        svridSet(svrId);
    }, [firstSvrId, params]);

    if (!listData) return null;

    return (
        <section className="gameinfo-result__list">
            {loading && (
                <div className="gameinfo-loader is-show">
                    <span className="loader" />
                </div>
            )}

            {listData.length < 1 && (
                <div className="nodata" style={{ display: 'block' }}>
                    <Trans components={{ i: <i />, div: <div /> }} i18nKey={setNoResultandFavs(params)} />
                </div>
            )}

            <div
                className={classNames({ allserver: svrid === 'all' }, { selectedserver: svrid !== 'all' }, 'ui-table')}
                data-tabletype="itemprice"
                style={{ display: listData.length < 1 ? 'none' : 'block' }}
            >
                <div className="tablehead">
                    <div className="tablerow">
                        <div className="tablecell favorite" />
                        <div className="tablecell itemname">{t('common.itemname')}</div>
                        {svrid === 'all' ? (
                            <>
                                <div className="tablecell server">{t('noti.server')}</div>
                                <div className="tablecell min-price">
                                    {t('noti.lowestprice')}
                                    <button
                                        className="ico-q"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={t('common.tooltiptheaditemprice1')}
                                    />
                                    <Tooltip disableStyleInjection={'core'} id="my-tooltip" />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="tablecell min-price">
                                    {t('noti.lowestprice')}
                                    <button
                                        className="ico-q"
                                        data-tooltip-id="my-tooltip2"
                                        data-tooltip-content={t('common.tooltiptheaditemprice1')}
                                    />
                                    <Tooltip disableStyleInjection={'core'} id="my-tooltip2" />
                                </div>
                                <div className="tablecell avg-price">
                                    {t('common.avgprice')}
                                    <button
                                        className="ico-q"
                                        data-tooltip-id="my-tooltip3"
                                        data-tooltip-content={t('common.tooltiptheaditemprice2')}
                                    />
                                    <Tooltip disableStyleInjection={'core'} id="my-tooltip3" />
                                </div>
                            </>
                        )}
                        <div className="tablecell qty">{t('common.listitems')}</div>
                    </div>
                </div>
                <div className="tablebody">
                    {listData.map((it, idx) => (
                        <PriceItem
                            key={
                                idx +
                                it.itemId +
                                it.favorite.toString() +
                                it.enchantLevel +
                                it.quantity +
                                it.grade +
                                it.serverId +
                                params.paramBless +
                                params.paramPage +
                                params.paramQuery
                            }
                            it={it}
                            svrid={svrid}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

const setNoResultandFavs = (params: IPriceParams) => {
    const { paramSale, paramFavorite } = params;
    let result = '';
    if (paramSale === 'false' && paramFavorite !== 'true') {
        result = 'common.noresultsitemprice';
    } else if (paramSale !== 'false' && paramFavorite !== 'true') {
        result = 'price.noteresultsitemprice';
    } else if (paramFavorite === 'true') {
        result = 'common.noresultsfavs';
    }
    return result;
};
